export default {
	events: {
		'ddc.form.confirmation': [
			{
				payload: {
					tealium_event: 'identity_event',
					customer_email:
						'[[eventData.fieldsTrimmedLowerCase.email]]',
					customer_phone:
						'[[eventData.fieldsTrimmedLowerCase.phone]]',
					customer_first_name:
						'[[eventData.fieldsTrimmedLowerCase.firstName]]',
					customer_last_name:
						'[[eventData.fieldsTrimmedLowerCase.lastName]]',
					text_opt_in: false
				}
			}
		]
	}
};
